<template>
    <div :class="$style.placeholder" />
</template>
<script setup></script>
<style module>
@keyframes blink {
    0%,
    100% {
        opacity: 0.08;
    }

    38%,
    50% {
        opacity: 0.16;
    }

    88% {
        opacity: 0.08;
    }
}

.placeholder {
    /* it's important to animate opacity, not background to avoid repaint  */
    background-color: var(--white);
    animation: blink 1.4s infinite;
}
</style>
